






























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import CreditcardForm from '@spa/components/organisms/payment/creditcard/CreditcardForm.vue'
import { CreditcardFormState } from '@spa/components/organisms/payment/creditcard/creditcardFormState'
import SpaCreditCardDescription from '@spa/components/organisms/payment/description/CreditCardDescription.vue'

import ExtraProfile, { emptyProfileFormState, ExtraProfileFormState } from './creditcard-extra-profile/ExtraProfile.vue'

@Component({
  components: {
    ExtraProfile,
    SpaCreditCardDescription,
    CreditcardForm,
  },
})
export default class NewCreditcard extends Vue {
  formState: CreditcardFormState = {
    cardNumber: '',
    cardOwner: '',
    expireMonth: '',
    expireYear: '',
    securityCode: '',
  }

  extraProfileFormState: ExtraProfileFormState = emptyProfileFormState()

  @Prop({ default: emptyProfileFormState() })
  defaultExtraProfileFormState: ExtraProfileFormState

  async created() {
    this.extraProfileFormState = this.defaultExtraProfileFormState
  }

  async validateAll(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async submit() {
    const validated = await this.validateAll()

    if (!validated) {
      return
    }

    this.$emit('register-creditcard', {
      creditcardFormState: this.formState,
      extraProfileFormState: this.extraProfileFormState,
    }as RegisterCreditcardEmit)
  }
}

export interface RegisterCreditcardEmit {
  creditcardFormState: CreditcardFormState,
  extraProfileFormState: ExtraProfileFormState,
}
